export const templateArray = [
	{
		type: 3,
		order: [],
	},
	{
		type: 4,
		order: [-1, 2, 0, 1],
	},
	{
		type: 4,
		order: [-1, 0, 1, 2],
	},
	{
		type: 4,
		order: [-1, 0, 2, 1],
	},
	{
		type: 4,
		order: [-1, 1, 0, 2],
	},
	{
		type: 5,
	},
	{
		type: 4,
		order: [0, 2, 1, 3],
	},
	{
		type: 4,
		order: [0, 3, 1, 2],
	},
	{
		type: 1,
		order: [],
	},
	{
		type: 2,
		order: [],
	},
	{
		type: 6,
		order: [],
	},
	{
		type: 7,
		order: [],
	},
];
export enum RATING_TYPES {
	Star,
	Smiley,
}
export const RATING_SMILEY_ID_MAPPING: {
	[id: number]: { type: number; count: number };
} = {
	1: { type: RATING_TYPES.Star, count: 3 },
	2: { type: RATING_TYPES.Star, count: 5 },
	3: { type: RATING_TYPES.Star, count: 10 },
	4: { type: RATING_TYPES.Smiley, count: 3 },
	5: { type: RATING_TYPES.Smiley, count: 5 },
};

// export const FF_RATING_SMILEY_ID_MAP: {
// 	[id: number]: { type: number; count: number };
// } = {
// 	1: { type: RATING_TYPES.Star, count: 5 },

// 	2: { type: RATING_TYPES.Smiley, count: 5 },

// 	3: { type: RATING_TYPES.Smiley, count: 3 },
// };

export enum FileSizeUnitMapping {
	KB = 1,
	MB = 2,
}

export enum ResponseTypes {
	SIMPLE = 'SIMPLE',
	FILEUPLOAD = 'FileUpload',
	MULTICHOICE = 'MULTICHOICE',
	MULTISELECT = 'MULTISELECT',
	LIST = 'LIST',
	CARD = 'CARD',
	CAROUSEL = 'CAROUSEL',
	TABLE = 'TABLE',
}
